import {
    httpGetAccessTypes,
    HttpGetAccessTypesOptions,
    HttpGetAccessTypesResponse
} from '@/features/access-types/http/accessTypes.http'
import {QUERY_KEYS} from '@/queryClient'
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'

export const useGetAccessTypes = ({
    params,
    options
}: {
    params: HttpGetAccessTypesOptions['params']
    options?: Pick<UseInfiniteQueryOptions<HttpGetAccessTypesResponse>, 'enabled'>
}) => {
    return useInfiniteQuery({
        queryKey: [QUERY_KEYS.ACCESS_TYPES, params],
        queryFn: ({pageParam = 1}) => httpGetAccessTypes({params: {...params, page: pageParam}}),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
}
